<template>
    <BaseModal
        :id="'changes-confirmation'"
        :title="'Room Type Change'"
        :message="'You have changed the Room Type associated with this room. Please confirm which of the following associated information you would like to set to default as a result of this change.'"
    >
        <template v-slot:content>
            <div class="col-12 p-0">
                <form class="mt-3" @submit.prevent="submit_confirmation()">
                    <span class="custom-control custom-checkbox" style="margin-top:40px;">
                        <input 
                            class="custom-control-input"
                            :type="'checkbox'"
                            v-model="floor_confirm"
                            :id="`floor_confirm`"
                        />
                        <label
                            class="custom-control-label ml-2"
                            v-html="`<b style='color:black;'>Floor Type.</b> The new floor type would be <b style='color:#008AD8'>${floor_name_confirmation}</b>`"
                            :for="`floor_confirm`"
                        />
                    </span>
                    <span class="custom-control custom-checkbox" style="margin-top:10px;">
                        <input 
                            :disabled="blocked_checked"
                            class="custom-control-input"
                            :type="'checkbox'"
                            v-model="project_confirm"
                            :id="`project_confirm`"
                        />
                        <label
                            class="custom-control-label ml-2"
                            v-html="`<b style='color:black;'>Project Task(s).</b> The project tasks associated with the floor type on the room record will be applied to this room record with their default frequencies.`"
                            :for="`project_confirm`"
                        />
                    </span>
                    <div class="modal__buttons text-center text-md-right">
                        <button type="button" class="modal__buttons__item cancel" data-dismiss="modal" aria-label="Close" v-html="'Cancel'"/>
                        <button class="modal__buttons__item" v-html="`Continue`"/>
                    </div>
                </form>
            </div>
        </template>
    </BaseModal>
</template>

<style scoped>
    .black-label{
        color:black;
    }
</style>

<script>

import BaseModal from '@/components/BaseModal'

export default {

    name: "ModalChangesConfirmation",

    props: [
      'floor_name_confirmation',
    ],

    components:{
        BaseModal,
    },

    data(){
        return{
            floor_confirm: false,
            project_confirm: false,
            // blocked_checked: true,
        }
    },

    watch: {
        floor_confirm(val)
        {
            if(!val)
            {
                this.project_confirm = false
            }
        },

        project_confirm(val)
        {
            this.$emit('projectConfirmMutation', val)
        }
    },

    computed: {

        blocked_checked()
        {
            return !this.floor_confirm
        }

    },

    methods: {

        submit_confirmation()
        {
            this.$emit('ReturnConfirmation', this.floor_confirm)
        }

    },

  mounted() {},

};
</script>